import React from 'react'
import { Loading } from '@shared/Loading'

const LazyLogin = React.lazy(
  () => import(/* webpackChunkName: "Login" */ './LineNotifyOauthEndpoint')
)

export default function LineNotifyOauthEndpoint() {
  return (
    <React.Suspense fallback={<Loading />}>
      <LazyLogin />
    </React.Suspense>
  )
}
